import About from './Dashboard.vue';

export default About;
